import { Col } from "@amzn/stencil-react-components/layout";
import {
  Link,
  LinkTextDecorationOptions,
} from "@amzn/stencil-react-components/link";
import { Text } from "@amzn/stencil-react-components/text";
import React from "react";
import { FormattedMessage } from "react-intl";

import { OPERATING_SYSTEM } from "@/helpers/os-helper";

function OSSpecificOrderedItems({ isMac }: { isMac: boolean }) {
  if (isMac) {
    return (
      <>
        <li>
          <Text>
            <FormattedMessage id="allStepsCompleted-mac-postLoginStep1" />
          </Text>
          <ol type="a">
            <li>
              <Text>
                <FormattedMessage id="allStepsCompleted-mac-postLoginStep1-substep1" />
              </Text>
            </li>
          </ol>
        </li>
        <li>
          <Text>
            <FormattedMessage id="allStepsCompleted-mac-postLoginStep2" />
          </Text>
        </li>
      </>
    );
  } else {
    return (
      <>
        <li>
          <Text>
            <FormattedMessage id="allStepsCompleted-win-postLoginStep1" />
          </Text>
        </li>
        <li>
          <Text>
            <FormattedMessage id="allStepsCompleted-win-postLoginStep2" />
          </Text>
        </li>
      </>
    );
  }
}

/**
 * Show a list of instructions for completing the post-login setup on day-1.
 */
export default function PostLoginInstructions({
  os,
}: {
  os: string;
}): JSX.Element {
  const isMac = os === OPERATING_SYSTEM.MAC;
  const newHirePortalLinkUrl = `https://my.it.a2z.com/postlogin/newhire/${
    isMac ? "mac" : "win"
  }`;

  return (
    <Col>
      <ol data-test-id={`postLogin${isMac ? "Mac" : "Wins"}Steps`}>
        <Col gridGap="S200" padding="0.8rem 0">
          <OSSpecificOrderedItems isMac={isMac} />
          <li data-test-id="postLoginStep3">
            <Text>
              <FormattedMessage
                id="allStepsCompleted-postLoginStep3"
                values={{
                  newHirePortalLinkUrl: (
                    <Link
                      target="_blank"
                      href={newHirePortalLinkUrl}
                      rel="noopener noreferrer"
                      display="inline"
                      textDecoration={LinkTextDecorationOptions.None}
                      fontWeight="normal"
                      className="wizard-link"
                    >
                      {newHirePortalLinkUrl}
                    </Link>
                  ),
                }}
              />
            </Text>
          </li>
          <Text fontWeight="bold">
            <FormattedMessage id="allStepsCompleted-reminder" />
          </Text>
        </Col>
      </ol>
    </Col>
  );
}
